import { NotificationBell } from '@features/notificacoes';
import { Header, Input, SidebarTrigger } from '@ntconsult/aluma-react';
import { Search } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LanguageMenu } from './LanguageMenu';
import { ThemeMenu } from './ThemeMenu';
import { UserMenu } from './UserMenu';

/** Campo de busca do header → tela de resultados (SPEC 8.1 / app-shell UX-D-2). */
function HeaderSearch() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  return (
    <form
      className="w-full max-w-md"
      onSubmit={(e) => {
        e.preventDefault();
        const term = q.trim();
        if (term) navigate(`/busca?q=${encodeURIComponent(term)}`);
      }}
    >
      <Input
        type="search"
        value={q}
        onChange={(e) => setQ(e.currentTarget.value)}
        placeholder={t('searchPlaceholder')}
        leftIcon={<Search size={16} aria-hidden />}
        aria-label={t('search')}
      />
    </form>
  );
}

export function AppHeader() {
  return (
    <Header>
      <Header.Start>
        <SidebarTrigger />
      </Header.Start>
      <Header.Center>
        <HeaderSearch />
      </Header.Center>
      <Header.End>
        <NotificationBell />
        <LanguageMenu />
        <ThemeMenu />
        <UserMenu />
      </Header.End>
    </Header>
  );
}
